// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.multiplex.amenities.RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create,
  RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyMultiplexAmenityCreateResponseV2WebDto,
  UserPropertyMultiplexAmenityCreateV2RequestDto,
  UserPropertyMultiplexAmenityDeleteResponseV2WebDto,
  UserPropertyMultiplexAmenityDeleteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Args {
  postData: UserPropertyMultiplexAmenityCreateV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Options = UseMutationOptions<
  UserPropertyMultiplexAmenityCreateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Args
>;

/**
 * Create a free text property amenity on every unit in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Args) =>
      RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Args {
  postData: UserPropertyMultiplexAmenityDeleteV2RequestDto;
}

export type RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Options = UseMutationOptions<
  UserPropertyMultiplexAmenityDeleteResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Args
>;

/**
 * Delete a free text property amenity from every unit in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete(args.postData, httpClient),
  });
};
